/*
 * komi: limpeza do atributo _komi_leve (Leve nativo, 18/10/2026).
 *
 * Até 18/10 o tema calculava o Leve e gravava a conta no atributo _komi_leve da sacola, que o
 * Finalizar da Marcha levava junto no /cart.js. Atributo de sacola é editável por quem compra, então
 * ele não pode dizer quanto se cobra: o Leve passou a ser desconto automático da própria Shopify e o
 * valor que vale é o total da Shopify (cart.total_price e os descontos do /cart.js).
 *
 * Este script não grava conta nenhuma e não segura o Finalizar. Ele só apaga o _komi_leve que tenha
 * ficado numa sacola aberta antes da troca, para o checkout não receber um número velho.
 *
 * 23/10/2026: o tema não grava mais o atributo, então basta conferir uma vez por navegador, em vez
 * de ler o /cart.js em toda página vista.
 * shortcut: a sacola da Shopify dura 14 dias, então depois de 01/11/2026 este script pode sair do layout.
 */

const CONFERIDO = 'komi_leve_antigo_conferido';

function jaConferido() {
  try {
    return localStorage.getItem(CONFERIDO) === '1';
  } catch {
    return false;
  }
}

async function limparAtributoAntigo() {
  if (jaConferido()) return;
  const raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const resposta = await fetch(`${raiz}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
  if (!resposta.ok) return;
  const sacola = await resposta.json();
  if (sacola && sacola.attributes && '_komi_leve' in sacola.attributes) {
    // valor vazio apaga o atributo
    const limpeza = await fetch(`${raiz}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { _komi_leve: '' } }),
    });
    if (!limpeza.ok) return;
  }
  try {
    localStorage.setItem(CONFERIDO, '1');
  } catch {}
}

limparAtributoAntigo().catch(() => {});
